import { render, staticRenderFns } from "./IconCakeSolid.vue?vue&type=template&id=7cdddb76"
import script from "./IconCakeSolid.vue?vue&type=script&lang=js"
export * from "./IconCakeSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports